import { Close } from '@mui/icons-material';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { Alert, Box, IconButton } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import commonActions, { selectors } from '../../modules/common';

const styles = {
  borderRadius: 4,
  boxShadow: '0 0 5px 0px #0000006e',
  left: 0,
  margin: {
    md: '0 auto',
    xs: '0 24px',
  },
  maxWidth: {
    lg: '33%',
    md: '50%',
    xs: 'auto',
  },
  opacity: 0.95,
  position: 'fixed',
  right: 0,
  top: 24,
  xs: {
    margin: '0 24px',
    maxWidth: 'auto',
  },
  zIndex: 9999,
};

export function MaintenanceBanner({ isVersionWarningDisplayed }: { isVersionWarningDisplayed: boolean }) {
  const dispatch = useDispatch();
  const bannerMessage = useSelector(selectors.getMaintenanceBannerMessage);
  const titleMessage = useSelector(selectors.getMaintenanceBannerTitle);

  if (!bannerMessage) return <>{false}</>;

  return (
    <Box sx={{ ...styles, ...(isVersionWarningDisplayed && { top: 52 }) }}>
      <Alert
        variant="filled"
        icon={<ReportProblemIcon />}
        sx={{ color: (theme: Theme) => theme.palette.warning.contrastText, fontWeight: 'normal' }}
        severity="warning"
        action={
          <IconButton
            size="small"
            onClick={() => {
              dispatch(commonActions.maintenanceBannerHide());
            }}
            sx={{ color: (theme: Theme) => theme.palette.warning.contrastText }}
          >
            <Close />
          </IconButton>
        }
      >
        {titleMessage && (
          <div>
            <b>{titleMessage}</b>&nbsp;
          </div>
        )}
        <div>{bannerMessage}</div>
      </Alert>
    </Box>
  );
}
